import { render, staticRenderFns } from "./KoioteSelector.vue?vue&type=template&id=ca7537d0&lang=es"
import script from "./KoioteSelector.vue?vue&type=script&lang=js"
export * from "./KoioteSelector.vue?vue&type=script&lang=js"
import style0 from "./KoioteSelector.vue?vue&type=style&index=0&id=ca7537d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports